/**
 * 激活码相关工具函数
 */

// 写死的激活码（用于验证）
const VALID_ACTIVATION_CODE = 'Y!lxKi8QgkFVHCjB'

// 缓存键名
const ACTIVATION_STORAGE_KEY = 'rpi_activation_info'

/**
 * 获取激活码信息
 * @returns {Object|null} 激活码信息对象 {code, type, timestamp} 或 null
 */
function getActivationInfo() {
  try {
    const infoStr = localStorage.getItem(ACTIVATION_STORAGE_KEY)
    if (!infoStr) return null
    
    return JSON.parse(infoStr)
  } catch (error) {
    console.error('获取激活码信息失败:', error)
    return null
  }
}

/**
 * 检查是否已激活
 * @returns {boolean} 是否已激活（只要存在激活码就返回 true）
 */
export function isActivated() {
  try {
    const info = getActivationInfo()
    return info !== null && info.code && info.code.trim() !== ''
  } catch (error) {
    console.error('检查激活状态失败:', error)
    return false
  }
}

/**
 * 保存激活码到缓存
 * @param {string} code 激活码
 * @param {string} type 激活码类型：'url'（URL参数）或 'verified'（已验证）
 * @returns {boolean} 是否保存成功
 */
export function saveActivationCode(code, type = 'verified') {
  try {
    if (!code || !code.trim()) {
      return false
    }

    const activationInfo = {
      code: code.trim(),
      type: type, // 'url' 或 'verified'
      timestamp: new Date().toISOString()
    }

    localStorage.setItem(ACTIVATION_STORAGE_KEY, JSON.stringify(activationInfo))
    return true
  } catch (error) {
    console.error('保存激活码失败:', error)
    return false
  }
}

/**
 * 验证激活码（仅用于手动输入的激活码验证）
 * @param {string} code 要验证的激活码
 * @returns {boolean} 是否有效
 */
export function validateActivationCode(code) {
  return code === VALID_ACTIVATION_CODE
}

/**
 * 清除激活码缓存
 */
export function clearActivationCode() {
  try {
    localStorage.removeItem(ACTIVATION_STORAGE_KEY)
  } catch (error) {
    console.error('清除激活码失败:', error)
  }
}

/**
 * 获取激活时间
 * @returns {string|null} 激活时间字符串或null
 */
export function getActivationTime() {
  try {
    const info = getActivationInfo()
    return info ? info.timestamp : null
  } catch (error) {
    console.error('获取激活时间失败:', error)
    return null
  }
}

/**
 * 获取激活码类型
 * @returns {string|null} 激活码类型 'url' 或 'verified'，或 null
 */
export function getActivationType() {
  try {
    const info = getActivationInfo()
    return info ? info.type : null
  } catch (error) {
    console.error('获取激活码类型失败:', error)
    return null
  }
}

/**
 * 获取激活码
 * @returns {string|null} 激活码字符串或null
 */
export function getActivationCode() {
  try {
    const info = getActivationInfo()
    return info ? info.code : null
  } catch (error) {
    console.error('获取激活码失败:', error)
    return null
  }
}
